<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { LOGO_SVG } from '../brand/logo'
import { localizedPath } from '../i18n/routing'

const { t, locale } = useI18n()

// The homepage in the language on screen; following the logo must not reset it.
const href = computed(() => localizedPath('/', locale.value))
</script>

<template>
  <a class="site-logo" :href="href">
    <!-- A trusted constant, not user input: the same markup the static pages emit. -->
    <span v-html="LOGO_SVG" />
    <span class="visually-hidden">{{ t('shell.siteName') }}</span>
  </a>
</template>
